import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { ensureBoolean, i18nIntl, isNotEmpty, parseClasses } from '../../../lib/ep.js';

import ActionButton from '../../builder/ActionButton';
import ActionLink from '../../builder/ActionLink';
import CopyLink from '../../builder/CopyLink';
import ShareTestMessage from '../../builder/ShareTestMessage';

import FloatingLayerPublic from '../FloatingLayerPublic';

import FB from '../share/FB';
import Twitter from '../share/Twitter';
import Pinterest from '../share/Pinterest';
import Linkedin from '../share/Linkedin';
import SendByMail from '../share/SendByMail';
import WhatsApp from '../share/WhatsApp';
import Line from '../share/Line';
import Telegram from '../share/Telegram';
import Threads from '../share/Threads';
import ButtonCollection from '../../builder/ButtonCollection.js';

function selectAllText(element_id) {
	const doc = document;
	const text = doc.getElementById(element_id);
	let range, selection;

	if(doc.body.createTextRange) {
		range = doc.body.createTextRange();
		range.moveToElementText(text);
		range.select();
	} else if (window.getSelection) {
		selection = window.getSelection();
		range = doc.createRange();
		range.selectNodeContents(text);
		selection.removeAllRanges();
		selection.addRange(range);
	}
};

const default_share_props = {
	status:'1',
	networks:{
		facebook:'1',
		twitter:'1',
		threads:'1',
		pinterest:'1',
		linkedin:'1',
		email:'1',
		whatsapp:'1',
		line:'1',
		telegram:'1',
	},
};

const ShareButton = (props) => {
	const [ layer_visible, setLayerVisible ] = useState(false);
	const promotion = props?.promotion ?? false;
	if(promotion === false) return null;

	const share_config = promotion?.config?.share ?? default_share_props;

	const show_share_btn = ((share_config?.status ?? '0') == '1') ? true : false;
	if(!show_share_btn) return null;

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const label = (isNotEmpty(props, 'children')) ? props.children : "Share";
	const is_builder = props?.is_builder ?? false;
	const force_display_layer = (is_builder) ? (props?.force_display_layer ?? false) : false;

	let shared_url = props?.url ?? false;
	if(shared_url === false) {
		const share_url_base = (!is_builder) ? `https://${window.domain_url}` : window.public_url;
		shared_url = `${share_url_base}p/${promotion.id}`;
	}

	const is_test = (!force_display_layer) ? (promotion?.test ?? false) : true;
	const info = props?.info ?? {};
	const layer_title = props?.layer_title ?? label;
	const cta_type = props?.cta_type ?? 'button';
	const type = props?.type ?? null;
	const sharing_type = props?.sharing_type ?? null;
	const sharing_page = props?.sharing_page ?? null;
	const is_mobile = props?.is_mobile ?? false;

	const networks = share_config?.networks ?? {};
	const has_facebook = (ensureBoolean(networks?.facebook ?? '0')) ? true : false;
	const has_twitter = (ensureBoolean(networks?.twitter ?? '0')) ? true : false;
	const has_pinterest = (ensureBoolean(networks?.pinterest ?? '0')) ? true : false;
	const has_linkedin = (ensureBoolean(networks?.linkedin ?? '0')) ? true : false;
	const has_mail = (ensureBoolean(networks?.email ?? '0')) ? true : false;
	const has_whatsapp = (ensureBoolean(networks?.whatsapp ?? '0')) ? true : false;
	const has_line = (ensureBoolean(networks?.line ?? '0')) ? true : false;
	const has_telegram = (ensureBoolean(networks?.telegram ?? '0')) ? true : false;
	const has_threads = (ensureBoolean(networks?.threads ?? '0')) ? true : false;
	let custom_text = "";
	switch(type) {
		case 'recruits':
			//custom_text = i18n("Share this link to refer new users to join the promotion");
			break;

		case 'votes':
			custom_text = i18n("Send this link directly to your contacts and friends so they can vote for this entry");
			break;
	}

	if(type == 'votes' && promotion.thank_you_on_vote != undefined && promotion.thank_you_on_vote != "") {
		custom_text = promotion.thank_you_on_vote;
	}

	const selectText = (element) => {
		selectAllText(element);
	};

	const setVisible = () => {
		setLayerVisible(true)
		if (props?.onOpenLayer) props.onOpenLayer();
	}

	const share_props = {
		type:sharing_type,
		page:sharing_page,
		user_id:info?.uid ?? null,
		promotion_id:promotion?.id ?? null,
	};

	let cta_classes = props?._class ?? {};
	if(cta_classes.other == undefined) {
		cta_classes.other = 'share_btn';
	} else {
		cta_classes.other += ' share_btn';
	}

	if(cta_type == 'button') {
		cta_classes = parseClasses('gui_big_button flex_button', cta_classes, 'button');
	}

	return (
		<>
			{(!force_display_layer) && (
				<>
					{(cta_type == 'simple_button') && (
						<ActionButton
							_class={cta_classes}
							color={false}
							icon={props?.icon ?? null}
							onClick={(!is_builder) ? setVisible : props.custom_onClick}
						>{label}</ActionButton>
					)}

					{(cta_type == 'button') && (
						<div class={cta_classes}>
							<ActionButton
								_fullclass=""
								icon={props?.icon ?? null}
								onClick={(!is_builder) ? setVisible : props.custom_onClick}
							>{label}</ActionButton>
						</div>
					)}

					{(cta_type == 'link') && (
						<ActionLink
							icon={props?.icon ?? null}
							_class={cta_classes}
							onClick={(!is_builder) ? setVisible : props.custom_onClick}
						>{label}</ActionLink>
					)}
				</>
			)}

			{(force_display_layer || layer_visible) && (
				<FloatingLayerPublic
					backButton={(!force_display_layer) ? () => setLayerVisible(false) : null}
					title={`<h1>${i18n(layer_title)}</h1>`}
					enable_behavior={props.enable_behavior}
					is_builder={is_builder}
				>
					<div class="gui_main_text_color_on_bg">
						{(custom_text != undefined && custom_text != "") && (
							<p class="extra_text" dangerouslySetInnerHTML={{ __html:custom_text.replace(/\n/g, '<br />') }} />
						)}
						
						<ShareTestMessage
							is_test={(!force_display_layer && is_test) ? true : false}
						/>

						<ButtonCollection _class={{other:"share_on_social public_share gui_not_in_bottom_big gui_flex_col gui_flex_align_top"}}>
							{(has_facebook) && (
								<FB
									linkable={!is_test}
									url={info.url}
									share={{...share_props, fbtype:'facebook', url:info.url, img:info.image, abrev:'fb'}}
									_fullclass="simple_default ep-facebook is_facebook in_top"
									autotranslate={false}
								>Facebook</FB>
							)}

							{(has_twitter) && (
								<Twitter
									linkable={!is_test}
									url={info.url}
									post={info.postenc}
									share={share_props}
									_fullclass="simple_default ep-twitter is_twitter in_top"
									autotranslate={false}
								>Twitter</Twitter>
							)}

							{(has_threads) && (
								<Threads
									linkable={!is_test}
									url={info.url}
									post={info.postenc}
									share={share_props}
									_fullclass="simple_default ep-threads is_threads in_top"
									autotranslate={false}
								>Threads</Threads>
							)}

							{(has_pinterest) && (
								<Pinterest
									linkable={!is_test}
									url={info.url}
									img={info.image}
									post={info.postenc}
									share={share_props}
									_fullclass="simple_default ep-pinterest is_pinterest in_top"
									autotranslate={false}
								>Pinterest</Pinterest>
							)}

							{(has_linkedin) && (
								<Linkedin
									linkable={!is_test}
									url={info.url}
									img={info.image}
									post={info.postenc}
									share={share_props}
									_fullclass="simple_default ep-linkedin is_linkedin in_top"
									autotranslate={false}
								>Linkedin</Linkedin>
							)}

							{(has_mail) && (
								<SendByMail
									linkable={!is_test}
									url={info.url}
									subject={info.title}
									post={info.descriptionenc}
									share={share_props}
									_fullclass="simple_default ep-mail is_mail in_top"
								>Email</SendByMail>
							)}

							{(is_mobile && has_whatsapp) && (
								<WhatsApp
									linkable={!is_test}
									url={info.url}
									post={`${info.instantenc}%0D%0A${info.urlencodeparameter}`}
									_fullclass="simple_default ep-whatsapp is_whatsapp in_top"
									share={share_props}
									autotranslate={false}
								>WhatsApp</WhatsApp>
							)}

							{(is_mobile && has_line) && (
								<Line
									linkable={!is_test}
									url={info.url}
									post={`${info.instantenc}%0D%0A${info.urlencodeparameter}`}
									_fullclass="simple_default ep-line is_line in_top"
									share={share_props}
									autotranslate={false}
								>Line</Line>
							)}

							{(is_mobile && has_telegram) && (
								<Telegram
									linkable={!is_test}
									url={info.url}
									post={`${info.instantenc}%0D%0A${info.urlencodeparameter}`}
									_fullclass="simple_default ep-telegram is_telegram in_top"
									share={share_props}
									autotranslate={false}
								>Telegram</Telegram>
							)}

							
						</ButtonCollection>

						<ul class="share_link original_color_item">
							<li class="copy_label" style={{width:'100%'}}>
								{i18n("Or copy-paste this link")}
								<CopyLink
									_fullclass="copy_link copy_button"
									copy_link={info.url}
									copied_label="Copied!"
								>Copy link</CopyLink>
							</li>

							{/*<li id="select_link" class="link cutTextOnOverflow" onClick={() => selectText('select_link')}>{info.url}</li>*/}
							<li id="select_link" class="link">{info.url}</li>
						</ul>
					</div>
				</FloatingLayerPublic>
			)}
		</>
	)
}

export default injectIntl(ShareButton);